'use client';

import { useBranding } from '@/hooks/useBranding';

interface SystemLogoProps {
  className?: string;
  /** Se true e não houver logo, exibe o nome do sistema como texto. */
  fallbackToName?: boolean;
}

/** Logo configurada em Aparência; alt text usa o nome do sistema. */
export default function SystemLogo({ className = 'h-12 object-contain', fallbackToName = false }: SystemLogoProps) {
  const { nomeSistema, logoSrc } = useBranding();

  if (logoSrc) {
    return <img src={logoSrc} alt={nomeSistema} className={className} />;
  }

  if (fallbackToName) {
    return <span className="text-xl font-bold text-gray-800 truncate">{nomeSistema}</span>;
  }

  return null;
}
